export default "__VITE_ASSET__78T1eL4R__"